module.exports = __webpack_public_path__ + "static/media/mxn.273a4ddb.svg";